import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

import { ApiError } from "@/api/client";

export function ErrorBanner({ error, title }: { error: unknown; title?: string }) {
  const heading = title ?? "Request failed";
  const message =
    error instanceof ApiError
      ? `${error.code}: ${error.message}`
      : error instanceof Error
        ? error.message
        : "Unknown error";
  return (
    <Alert
      icon={<IconAlertCircle size={18} />}
      color="red"
      variant="light"
      title={heading}
      mb="md"
    >
      {message}
    </Alert>
  );
}
